import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";
import { useOne } from "src/system/useOne.tsx";
import { useCreateForm } from "src/system/useCreateForm.tsx";

export const useResourceFormQuery = () => {
  const { action, resource, lang, id, includes, meta } =
    useResourceFormContext();

  const createQueryResult = useCreateForm({
    resource,
    locale: lang,
    meta,
    queryOptions: {
      enabled: action === "create",
    },
  });

  const editQueryResult = useOne({
    lang: lang,
    id: id!,
    includes: includes,
    resource,
    meta,
    queryOptions: {
      enabled: action === "edit",
    },
  });

  return action === "edit" ? editQueryResult : createQueryResult;
};
